<fcom-modal
  [fitToContent]="true"
  [forceRemainOpen]="true"
  [open]="true"
  [title]="'MMB.checkIn.exitRowSeats.mainTitle' | finLocalization"
  [buttons]="ModalButtons.CUSTOM"
  [confirmEnabled]="true"
>
  <div class="pr-medium flex flex--column exit-row-panel">
    <div class="nordic-blue-25-bg ps-medium">
      <cms-unstyled-fragment class="requirements-list" [contentUrl$]="exitRowSeatRequirementsArticle$" />
    </div>
    <div class="flex flex--column exit-seats-form-info-block">
      <h2 class="title font-heading-5 bold-type nordic-blue-900">
        {{ 'MMB.checkIn.exitRowSeats.notifications.title' | finLocalization }}
      </h2>
    </div>
    <form [formGroup]="reactiveForm">
      <div class="flex flex--column exit-seat-question">
        <div class="flex flex--row flex--space-around form-subgroup">
          <span class="flex font-body-1 light-type passenger">
            <span class="nordic-blue-400-text regular-type">{{
              'MMB.checkIn.exitRowSeats.paxLabel' | finLocalization
            }}</span>
          </span>
          <span class="flex font-body-1 seat">
            <span class="nordic-blue-600-text bold-type">
              {{ 'MMB.checkIn.exitRowSeats.radioButtonLabel' | finLocalization }}
            </span>
          </span>
        </div>
        <div *ngFor="let pax of passengersWithExitSeats" class="flex flex--row flex--space-around form-subgroup">
          <span class="flex flex--column flex--left-center font-body-1 light-type passenger">
            <span class="medium-type">{{ pax.firstName + ' ' + pax.lastName }}</span>
          </span>
          <span class="seat">
            <fcom-radio-item-group
              [options]="[
                {
                  value: exitRowSeatConfirmationStatuses.meetRequirements.strValue,
                  label: exitRowSeatConfirmationStatuses.meetRequirements.label,
                },
                {
                  value: exitRowSeatConfirmationStatuses.notMeetRequirements.strValue,
                  label: exitRowSeatConfirmationStatuses.notMeetRequirements.label,
                },
              ]"
              [parentForm]="reactiveForm"
              [controlName]="pax.id"
              [isSensitive]="true"
              [isRequired]="true"
              [titleText]="false"
              [theme]="RadioButtonTheme.BOX"
              [translationPrefix]="'MMB.checkIn.exitRowSeats'"
            />
          </span>
        </div>
      </div>
    </form>
  </div>
  <div
    messageBox
    class="pr-xsmall flex form-information-message nordic-blue-25-bg"
    *ngIf="notMeetRequirementsChecked$ | async"
  >
    <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.INFO_BLOCK" />
    <span class="font-body-1">
      {{ 'MMB.checkIn.exitRowSeats.notifications.notMeetingRequirementsInfo' | finLocalization }}
    </span>
  </div>

  <div buttons>
    <fcom-button
      data-testid="checkin-seats-confirm-exit-row-seats-button"
      [mode]="ButtonMode.FILL_MOBILE"
      [text]="'MMB.checkIn.exitRowSeats.button.confirm' | finLocalization"
      (clickBtn)="onConfirmExitRowSeats()"
    />
  </div>
</fcom-modal>
